// /**
//  * Order -CSV
//  */

// React
import React from 'react';

import {CSVLink} from 'react-csv';

// UI
import {Button} from '@material-ui/core';

import {Product} from '../interfaces';
import RonadIcons from '../../../components/iconComponent';

type Props = {
  getData: any;
  data: Product[];
  id: string | number;
  filtersValues: any;
  loading: boolean;
};

function CSV(props: Props) {
  const handleCreateCSV = () => {
    props.getData({
      ...props.filtersValues,
      size: 10000,
      'partnerId.equals': props.id,
    });
  };
  const flattData = (data: any) => {
    const newData = data.map((item: any) => {
      return {...item};
    });

    return newData;
  };

  return (
    <>
      {props.data?.length > 0 ? (
        <CSVLink
          data={flattData(props.data)}
          filename="Products.csv"
          style={{
            backgroundColor: '#DFA01F',
            padding: '10px',
            color: '#fff',
            marginLeft: '5px',
            textDecoration: 'none',
          }}
        >
          دانلود CSV
        </CSVLink>
      ) : (
        <Button
          style={{marginLeft: '5px'}}
          variant="contained"
          color="primary"
          startIcon={<RonadIcons name='tableArrowUp' size={1} />}
          onClick={handleCreateCSV}
          disabled={props.loading}
        >
          ایجاد فایل CSV
        </Button>
      )}
    </>
  );
}

export default CSV;
